// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__DaoGd","image":"Header_image__3ec-V","name":"Header_name__3NESA","info":"Header_info__3x5lD","infoRow":"Header_infoRow__ul0Af"};